// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"4cfc47b2","174":"6f89f41d","311":"24cf7e13","354":"39ccf724","378":"e4e21a8a","453":"4ea553a9","550":"48541d46","605":"aeadb639","725":"c71f73d1","741":"7e9d97a2","755":"5f411eb8","943":"e75e0f38"}[chunkId] + ".chunk.js";
};